// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"523":"874c075a7acef259","742":"c65e628b1d691e99","752":"f8ad2290ffed18bf","789":"dcee16fdddb8b4e1"}[chunkId] + ".js";
};